// The access link the hospital gives patients carries the tenant's token. Two forms work:
//   https://<site>/?apiKey=<apiKey>&token=<token>   (what Tenant Setup > Generate produces)
//   https://<site>/<token>                           (token in the path)
// It is read from the address once, kept for the browser tab (a refresh or a move to another
// page of the app loses the address's query), and sent as x-api-token / x-api-key.

const STORAGE_KEY = "online_appointment_access";

// A "+" in a query value arrives as a space; put it back.
const fixPlus = (value) => (value ? value.replace(/ /g, "+") : null);

const fromQuery = (search) => {
	const params = new URLSearchParams(search || "");
	return { apiKey: fixPlus(params.get("apiKey")), token: fixPlus(params.get("token")) };
};

const APP_PAGES = ["appointment"];

const fromPath = (pathname) => {
	const first = String(pathname || "").split("/").filter(Boolean)[0];
	if (!first || APP_PAGES.includes(first)) return null;
	try {
		return decodeURIComponent(first);
	} catch (error) {
		return first;
	}
};

const readSaved = () => {
	try {
		return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
	} catch (error) {
		return {};
	}
};

const save = (access) => {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(access));
	} catch (error) {
		// private mode: the address still works for this page load
	}
};

/** { apiKey, token } for this browser tab; either can be null when the link has none. */
export function resolveAccess(location = window.location) {
	const query = fromQuery(location.search);
	const token = query.token || fromPath(location.pathname);
	if (token) {
		const access = { apiKey: query.apiKey, token };
		save(access);
		return access;
	}
	const saved = readSaved();
	return { apiKey: saved.apiKey ?? null, token: saved.token ?? null };
}
